function scrollToVariantSelectors() {
  const productInfo = document.querySelector('[id^="ProductInfo-"]');
  const variantPicker = document.querySelector('.product__info-container .product-form__input');
  const target = variantPicker || productInfo;
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

const stickyAtc = document.querySelector('.sticky-atc');
const stickyAtcButton = document.querySelector('.sticky-atc-button[data-add-to-cart]');
const stickyAtcText = stickyAtcButton?.querySelector('span');

const MAIN_ATC_SELECTOR = '.product__info-container .product-form__submit[name="add"]';
const SCROLL_THRESHOLD_PX = 24;

function getMainAddToCartButton() {
  return document.querySelector(MAIN_ATC_SELECTOR);
}

let stickyAtcHideTimer;

function setStickyAtcVisible(visible) {
  if (!stickyAtc) return;

  if (stickyAtcHideTimer) {
    clearTimeout(stickyAtcHideTimer);
    stickyAtcHideTimer = null;
  }

  stickyAtc.setAttribute('aria-hidden', visible ? 'false' : 'true');

  if (visible) {
    stickyAtc.style.display = 'flex';
    requestAnimationFrame(() => {
      stickyAtc.classList.add('is-visible');
    });
    return;
  }

  stickyAtc.classList.remove('is-visible');
  stickyAtcHideTimer = setTimeout(() => {
    if (!stickyAtc.classList.contains('is-visible')) {
      stickyAtc.style.display = 'none';
    }
    stickyAtcHideTimer = null;
  }, 300);
}

function getVisibleViewportBounds() {
  const vv = window.visualViewport;
  if (!vv) {
    return { top: 0, bottom: window.innerHeight };
  }
  return { top: vv.offsetTop, bottom: vv.offsetTop + vv.height };
}

function getPageScrollY() {
  return window.scrollY || document.documentElement.scrollTop || 0;
}

/**
 * Show sticky only after the main ATC has scrolled above the visible viewport.
 * Hides when ATC is visible or still below the fold (fixes mobile load false positive).
 */
function shouldShowStickyAtc() {
  const mainAddToCart = getMainAddToCartButton();
  if (!mainAddToCart) return false;

  const rect = mainAddToCart.getBoundingClientRect();
  const { top: viewportTop, bottom: viewportBottom } = getVisibleViewportBounds();

  if (rect.top >= viewportBottom) return false;

  if (rect.bottom > viewportTop && rect.top < viewportBottom) return false;

  if (rect.bottom <= viewportTop) {
    return getPageScrollY() > SCROLL_THRESHOLD_PX;
  }

  return false;
}

let stickyAtcRafId;

function scheduleStickyAtcUpdate() {
  if (!stickyAtc) return;
  if (stickyAtcRafId) return;
  stickyAtcRafId = requestAnimationFrame(() => {
    stickyAtcRafId = null;
    setStickyAtcVisible(shouldShowStickyAtc());
  });
}

function initStickyAtcVisibility() {
  if (!stickyAtc || !getMainAddToCartButton()) return;

  stickyAtc.setAttribute('aria-hidden', 'true');
  setStickyAtcVisible(false);

  window.addEventListener('scroll', scheduleStickyAtcUpdate, { passive: true });
  window.addEventListener('resize', scheduleStickyAtcUpdate, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleStickyAtcUpdate);
    window.visualViewport.addEventListener('scroll', scheduleStickyAtcUpdate);
  }

  window.addEventListener('pageshow', scheduleStickyAtcUpdate);
  window.addEventListener('load', scheduleStickyAtcUpdate, { once: true });
  setTimeout(scheduleStickyAtcUpdate, 400);
  setTimeout(scheduleStickyAtcUpdate, 1200);

  scheduleStickyAtcUpdate();
}

initStickyAtcVisibility();

stickyAtcButton?.addEventListener('click', function (event) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const id_input = document.querySelector('.sticky-atc-id');
  var error = false;
  if (!id_input) return;

  if (stickyAtcButton.getAttribute('aria-disabled') === 'true') return;

  stickyAtcButton.setAttribute('aria-disabled', true);
  stickyAtcButton.classList.add('loading');
  stickyAtcButton.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append(id_input.name, Number(id_input.value));
  formData.append('quantity', 1);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });

        const soldOutMessage = stickyAtc.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        stickyAtcButton.setAttribute('aria-disabled', true);
        stickyAtcText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        error = true;
        return;
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });
      error = false;
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      stickyAtcButton.classList.remove('loading');
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (!error) stickyAtcButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
});

subscribe('variant-change', (eventData) => {
  const variant = eventData.data.variant;
  if (!variant) return;

  const optionsText = document.querySelector('.atc-variant-options');
  const variantImage = document.querySelector('.atc-image');
  const idInput = document.querySelector('.sticky-atc-id');

  if (idInput) {
    idInput.value = variant.id;
  }

  if (optionsText) {
    const options = [variant.option1, variant.option2, variant.option3]
      .filter((opt) => opt)
      .join(', ');
    optionsText.textContent = options;
  }

  if (variantImage && variant.featured_image) {
    variantImage.src = variant.featured_image.src;
  }

  const soldoutDataEl = document.querySelector('#variant-soldout-data');
  if (!soldoutDataEl || !stickyAtcButton || !stickyAtcText) return;

  let soldoutData;
  try {
    soldoutData = JSON.parse(soldoutDataEl.textContent);
  } catch (e) {
    console.error('Failed to parse soldout data:', e);
    return;
  }

  const rules = soldoutData[variant.id];

  if (!rules) {
    stickyAtcButton.disabled = false;
    stickyAtcButton.setAttribute('aria-disabled', 'false');
    stickyAtcButton.style.opacity = '1';
    stickyAtcText.textContent =
      window.theme?.strings?.addToCart || 'Add to cart';
    scheduleStickyAtcUpdate();
    return;
  }

  let isSoldOut = false;

  const manualControlEnabled = document.body.dataset.manualInventoryControl === 'true';

  if (manualControlEnabled) {
    const manualRaw = rules.manualSoldOut;
    const manualSoldOut =
      manualRaw === true ||
      manualRaw === 'true' ||
      manualRaw === 1 ||
      manualRaw === '1';

    if (manualSoldOut) {
      isSoldOut = true;
    }

    if (rules.inventoryManaged === 'shopify') {
      const inventoryQty = Number(rules.inventoryQty);
      const continuePolicy = rules.continueSelling;

      if (continuePolicy !== 'continue' && inventoryQty <= 0) {
        isSoldOut = true;
      }
    }
  } else {
    const inventoryQty = Number(rules.inventoryQty);
    const denySelling =
      rules.inventoryManaged === 'shopify' &&
      rules.continueSelling !== 'continue' &&
      inventoryQty <= 0;

    isSoldOut = denySelling;
  }

  stickyAtcButton.disabled = isSoldOut;
  stickyAtcButton.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');
  stickyAtcButton.style.opacity = isSoldOut ? '0.75' : '1';

  stickyAtcText.textContent = isSoldOut
    ? window.theme?.strings?.soldOut || 'Sold out'
    : window.theme?.strings?.addToCart || 'Add to cart';

  scheduleStickyAtcUpdate();
});
